import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "@store/baseQuery";

export interface IAIResponse {
  id: number;
  provider: string | null;
  model: string;
  created_date: string;
  updated_date: string;
  deleted: boolean;
  decrypted_api_key: string;
  user: number;
}

interface IAIPayload {
  api_key?: string;
  provider: string;
}

interface IAIUpdatePayload {
  id: number | string;
  payload: {
    api_key?: string;
    provider?: string;
    use_default?: boolean;
  };
}

export const settingsApi = createApi({
  reducerPath: "settingsApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getAIConfig: builder.query<IAIResponse[], void>({
      query: () => ({
        url: "/settings/ai-configurations/",
        method: "GET",
      }),
    }),

    postAIConfig: builder.mutation<IAIResponse[], IAIPayload>({
      query: (body) => ({
        url: "/settings/ai-configurations/",
        method: "POST",
        body,
      }),
    }),

    patchAIConfig: builder.mutation<IAIResponse[], IAIUpdatePayload>({
      query: (body) => ({
        url: `/settings/ai-configurations/${body.id}/`,
        method: "PATCH",
        body: body.payload,
      }),
    }),
  }),
});

export const {
  useLazyGetAIConfigQuery,
  usePostAIConfigMutation,
  usePatchAIConfigMutation,
} = settingsApi;